import axios from "axios";
import { SuperAdminURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}organization`;

// Get organization All For use Combobox data
export function getorganizationAll() {
  return axios.get(URL);
}

export function getorganizationAllNotFiltered() {
  return axios.get(`${URL}/not_filtered`);
}

export function getorganizationAllCompany() {
  return axios.get(`${URL}/allcompany`);
}

// //Get By ID
export function getorganizationById(organizationId) {
  return axios.get(`${URL}/${organizationId}`);
}

// items => filtered/sorted result for table data
export function findorganization(queryParams) {
  return axios.post(`${URL}/find`, queryParams);
}

// POST => POST: Create the organization on the server
// export function createorganization(organization) {
//   return axios.post(URL, organization);
// }

// UPDATE => PUT: update the organization on the server
export function updateorganization(organization) {
  return axios.put(`${URL}/${organization.uuid}`, organization);
}

// ? UPDATE ORGANIZATION ACTIVATED
export const activatedOrganization = params => {
  return axios.put(`${URL}/activated`, params);
};

// ? FIND ORGANIZATION FILE
export const findOrganizationFile = params => {
  return axios.post(`${URL}/organization_file`, params);
};

// ? UPDATE ORGANIZATION ACTIVATED
export const updateSimpzStatus = params => {
  return axios.put(`${URL}/update_simpz_status`, params);
};

// ? CREATE ORGANIZATION
export const createOrganization = params => {
  return axios.post(`${URL}/create_organization`, params);
};

// ? CHECK ORGANIZATION DOMAIN
export const checkExistingOrg = params => {
  return axios.post(`${URL}/check_existing_org`, params);
};

export const exportOrganization = payload => {
  // return axios.post(`${URL}/export_organization`, payload);
  return axios({
    url: `${URL}/export_organization`,
    method: "POST",
    data: payload,
    responseType: "blob"
  });
};

// * SUPERADMIN EDIT ORGANIZATION DETAIL
export const updateOrganizationOwner = payload => {
  return axios.put(`${URL}/update_organization_owner`, payload);
};

// * SUPERADMIN LOGIN TO ORGANIZATION
export const loginToOrganization = payload => {
  return axios.post(`${URL}/login_to_organization`, payload);
};

// * SOFT DELETE ORGANIZATION
export const deleteOrganization = id => {
  return axios.delete(`${URL}/delete_organization/${id}`);
};

// * REVISION TO REUPLOAD DOCUMENT
export const reUploadOrgDocs = params => {
  return axios.put(`${URL}/reupload_org_document`, params);
};

// * REJECT ORGANIZATION
export const rejectOrganization = params => {
  return axios.post(`${URL}/reject_organization`, params);
};

// * Manual activate user organization
export function manualActivateUser(uuid) {
  return axios.put(`${URL}/manual_activate_user/${uuid}`);
}
